<template>
  <q-dialog
    persistent
    v-model="dialog"
  >
    <q-card
      flat
      bordered
      position="top"
      style="max-width: 400px; width: 90vw; "
      class="q-mt-md agent-transfer "
    >
      <q-toolbar
        dense
        color="primary"
      >
        <q-avatar>
          <q-icon
            name="mdi-account-switch-outline"
            color="primary"
            size="md"
            class="q-pa-none"
          />
        </q-avatar>

        <q-toolbar-title>
          <span class="text-weight-medium">Escolha um Agente</span>
        </q-toolbar-title>
      </q-toolbar>

      <q-separator inset />

      <q-card-section
        v-if="!loading"
        class=" row justify-center items-center height-325px q-mb-sm"
      >
        <q-spinner-ios
          color="primary"
          size="4em"
        />
      </q-card-section>

      <q-card-section
        v-else
        class="q-pb-xs scroll"
      >
        <q-item-section
          class="row height-25px q-mb-xs"
        >
          <div class="row full-height items-center q-mb-sm">
            <SearchIcon class="search-icon q-ma-sm absolute" />

            <input
              data-testid="transferencia-agente-busca"
              type="text"
              class="full-width input-search"
              v-model="filter"
              placeholder="Buscar por agente..."
            >
          </div>
        </q-item-section>

        <q-list
          dense
          class="custom-select-dropdown rounded-borders"
        >
          <template v-for="item in items">
            <AgentTransferListItem
              :active-agent="selectedAgent"
              :active-queue="selectedQueue"
              :agent="item"
              :key="`item-${item.id}`"
              @handle-queue-selection="handleQueueSelection"
            />
          </template>
        </q-list>
      </q-card-section>

      <q-separator />

      <q-card-actions align="around">
        <q-btn
          data-testid="transferencia-agente-cancelar"
          flat
          no-caps
          padding="5px 12px"
          color="primary"
          label="Cancelar"
          @click="onCancelClick"
        />

        <q-btn
          data-testid="transferencia-agente-confirmar"
          no-caps
          unelevated
          padding="5px 12px"
          color="primary"
          :disable="!selectedAgent || !selectedQueue"
          @click="confirmSelection"
        >
          Confirmar Seleção
        </q-btn>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import SearchIcon from '@/assets/icons/search.svg'
import AgentTransferListItem from './AgentTransferListItem'
import getEntryNumbers from '@/libs/getEntryNumbers'

export default {
  components: {
    SearchIcon,
    AgentTransferListItem
  },
  props: {
    value: Boolean,
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      agents: [],
      dialog: this.value,
      dialogVisible: false,
      filter: '',
      loading: false,
      selectedAgent: null,
      selectedQueue: null
    }
  },
  computed: {
    items () {
      const vm = this
      if (!vm.filter) return vm.agents
      return vm.agents.filter((agent) => agent.label.includes(vm.filter))
    }
  },

  mounted () {
    getEntryNumbers(true, false).then((entryNumbers) => {
      this.agents = entryNumbers.filter((i) => i.destinationType === 'AGENTCODE').map((i) => {
        let status = 'Ocupado'
        if (i.status === 'OFFLINE') status = 'Desconectado'
        if (i.status === 'PAUSED') status = 'Pausado'
        if (i.status === 'ONLINE') status = 'Disponível'

        return {
          id: i.number,
          label: `${i.description} #${i.number} (${status})`
        }
      })
    })
  },
  methods: {
    onCancelClick () {
      this.$emit('cancel')
      this.dialog = false
    },

    handleQueueSelection ({ queue, agent }) {
      this.selectedQueue = queue
      this.selectedAgent = agent
    },
    confirmSelection () {
      this.$emit('agent-selected', {
        agentId: this.selectedAgent?.id,
        queueId: this.selectedQueue?.queueId,
        agentName: this.selectedAgent?.label,
        queueName: this.selectedQueue?.name
      })
      this.dialog = false
      this.clearSelection()
    },

    clearSelection () {
      this.selectedAgent = null
      this.selectedQueue = null
    },

    showLoading () {
      this.loading = Boolean(this.agents.length)
    }
  },

  watch: {
    value (val) {
      this.dialog = val
    },
    dialog (val) {
      this.$emit('input', val)
    },
    agents () {
      this.showLoading()
    }
  }
}
</script>

<style lang="sass" scoped>
  .custom-select-dropdown
    height: 325px
    overflow-y: auto
  .agent-transfer
    .input-search
      border: none
      border: 1px solid #CDDCE5
      border-radius: 3px
      padding-left: 28px
      color: #01253C
      &:focus
        border: 1px solid #1769B6
        outline: none
      &:hover
        border: 1px solid #E3F2FD
      &::-webkit-input-placeholder
        color: #01253C
        opacity: 0.5
        font-style: normal
        font-weight: normal
        font-size: 12px
        line-height: 12px

    .search-icon
      height: 16px
      width: 16px

    .search-icon > stroke
      fill: #01253C66

  .height-25px
    height: 25px
    min-height: 25px

  .height-325px
    height: 325px
    min-height: 325px

.agent-item
  max-height: 25px
</style>
